// extracted by mini-css-extract-plugin
export default {"link":"RB-z","disabled":"SB-z"};